
export const finance = {
  accountingHub: {
    sidebar: {
      redemptionHistory: "Redemption History",
      chartOfAccounts: "Chart of Accounts"
    }
  },
  accounting: {
    title: "Accounting",
    loading: "Loading Financial Data...",
    table: {
      title: "Redemption Log",
      date: "Date",
      customer: "Customer",
      reward: "Reward",
      points: "Points Used",
      cost: "Cost Value"
    },
    kpi: {
      pointsRedeemed: "Points Redeemed",
      rewardCost: "Cost of Rewards"
    },
    cards: {
      totalRevenue: "Total Revenue",
      cogs: "COGS",
      grossProfit: "Gross Profit",
      netProfit: "Net Profit",
      expenses: "Expenses"
    },
    sections: {
      clinicRevenue: "Clinic Revenue",
      retailRevenue: "Retail Revenue",
      medicalServices: "Medical Services",
      generalGoods: "General Goods",
      topItems: "Top Items"
    }
  },
  billing: {
    title: "Billing & Subscription",
    description: "Manage your plan and view billing history.",
    currentPlan: "Current Plan",
    status: "Status:",
    manageButton: "Manage Subscription",
    perMonth: "/ month",
    usersUnit: "Medical Cases",
    productsUnit: "Items",
    unlimited: "Unlimited",
    upgradeButton: "Upgrade",
    currentPlanButton: "Current Plan",
    features: {
      reporting: "Reporting",
      aiorder: "AI Smart Order",
      telemedicine: "Tele-Medicine",
      loyalty: "Loyalty System",
      accounting: "Accounting",
      partnernetwork: "Partner Network",
      nfccards: "NFC Card System",
      compliancereports: "Compliance Reports"
    },
    summary: {
      title: "Current Month Summary",
      estimatedTotal: "Estimated Total",
      casesUsed: "Medical Cases Used",
      basePlan: "Base Plan Price",
      overageFees: "Overage Fees",
      total: "Total",
      remaining: "{{count}} cases remaining",
      overageWarning: "{{count}} cases over limit ({{rate}} THB/case)"
    }
  }
};
